"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
function isInboxRuleOptionEditState() {
    return store_1.default.inboxRulesEditState.clauseMap.size > 0;
}
exports.default = isInboxRuleOptionEditState;
//# sourceMappingURL=isInboxRuleOptionEditState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/isInboxRuleOptionEditState.js
// module id = 3757
// module chunks = 2